import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export abstract class RestService {

  abstract endpoint(): string;
  abstract param1(): string;
  abstract param2(): string;
  abstract param3(): string;
  token = {api_token: `${localStorage.getItem('token')}` }  ;

  constructor(protected http: HttpClient) {
  }

  get url() {
    return `${environment.api}/${this.endpoint()}`;
  }

  all(page?: number, param1?: string , param2?: number, param3?: string  ) {
    let url = this.url;

    if (page) {
      url += `?page=${page}`;
    }
    if (param1) {
      url += `&${this.param1()}=${param1}`;
    }
    if (param2) {
      url += `&${this.param2()}=${param2}`;
    }
    if (param3) {
      url += `&${this.param3()}=${param3}`;
    }

    return this.http.post(url,this.token);
  }

  allRecords( param1?: string , param2?: number, param3?: string  ) {
    let url = this.url + '/allRecords?';

    if (param1) {
      url += `&${this.param1()}=${param1}`;
    }
    if (param2) {
      url += `&${this.param2()}=${param2}`;
    }
    if (param3) {
      url += `&${this.param3()}=${param3}`;
    }

    return this.http.post(url,this.token);
  }

  get(id: number) {
    return this.http.get(`${this.url}/${id}`);
   //http://localhost:8000/api/v1/roles/1
   // http://127.0.0.1:8000/api/v1/roles
  }

  create(data) {

    return this.http.post(this.url, data);
  }

  update(id: number, data) {
    return this.http.put(`${this.url}/${id}`, data);
  }

  delete(id: number) {
    return this.http.delete(`${this.url}/${id}`);
  }
}
